import { getAnswerValue } from '../selectors/chat'
import { getDateTime } from './session'
import api from '../api'

export const CHAT_ANSWER = 'CHAT_ANSWER'
export const CHAT_MESSAGE = 'CHAT_MESSAGE'

const getTime = () => {
  const date = new Date()
  const f = v => v < 10 ? '0' + (v+1) : (v+1)
  return date.getDate() + '.' + f(date.getMonth()) + '.' + date.getFullYear() + ' в ' + date.getHours() + ':' + f(date.getMinutes())
}

export const makeAnswer = (question, answer, {session}) => ({
  datetime: getDateTime(),
  question, answer,
  session: session.id
})

export function answerChat(question, answer) {
  return (dispatch, getState) => {
    dispatch({type: CHAT_ANSWER, question, answer})
    api.answers.send(makeAnswer(
      question, getAnswerValue(question, answer), getState()
    ))
  }
}

export const messageChat = (question) => ({type: CHAT_MESSAGE, question, time: getTime()})



// WEBPACK FOOTER //
// ./actions/chat.js